"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const noop_1 = __importDefault(require("lodash-es/noop"));
const classnames_1 = __importDefault(require("classnames"));
const Input_1 = __importDefault(require("../../../Input"));
const success_svg_1 = __importDefault(require("../../../../icons/success.svg"));
const Button_1 = __importStar(require("../../../Button"));
// eslint-disable-next-line import/no-cycle
const index_1 = require("../../index");
const constants_1 = require("../../hoc/Tabbing/constants");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const DropdownMenuCreatableItem = ({ palette, size, readOnly = false, defaultValue = '', onCreate = noop_1.default, }) => {
    const [value, setValue] = (0, react_1.useState)(defaultValue);
    const handleCreate = (0, react_1.useCallback)(() => {
        onCreate(value.trim());
        setValue('');
    }, [onCreate, value]);
    const handleSubmit = (0, react_1.useCallback)((event) => {
        if (event.key === 'Enter') {
            handleCreate();
        }
    }, [handleCreate]);
    return ((0, jsx_runtime_1.jsx)("div", { role: "option", "aria-selected": false, className: (0, classnames_1.default)(styles_module_css_1.default.option, size && styles_module_css_1.default[size], { [styles_module_css_1.default[palette]]: palette }), children: (0, jsx_runtime_1.jsx)(Input_1.default, { role: constants_1.CREATE_OPTION_ROLE, "aria-details": constants_1.TABBING_KEY, value: value, onChange: setValue, onKeyDown: handleSubmit, boxComponent: index_1.InputBoxComponent, palette: palette, clearable: false, placeholder: "+ Add custom item", readOnly: readOnly, after: (0, jsx_runtime_1.jsx)(Button_1.default, { color: Button_1.ButtonColor.Green, size: Button_1.ButtonSize.Small, disabled: !value, onClickCapture: handleCreate, children: (0, jsx_runtime_1.jsx)(success_svg_1.default, { size: 10 }) }) }) }));
};
exports.default = DropdownMenuCreatableItem;
